// PrivacyPage.jsx
import React from "react";
import "./baseStyles.css";

export default function PrivacyPage() {
  return (
    <div className="legal-container">
      <h1>Privacy Policy</h1>
      <p>At MyDailyReminders, we respect your privacy and are committed to protecting your personal information.</p>

      <h2>Information We Collect</h2>
      <p>We collect your name, email, and phone number when you sign up. We also collect usage data to improve our services.</p>

      <h2>How We Use Your Data</h2>
      <p>We use your information to send reminders, provide customer support, and analyze app usage to improve user experience.</p>

      <h2>SMS and Communication</h2>
      <p>If you opt in, we send text messages as part of your campaigns. You can opt out anytime by replying STOP.</p>

      <h2>Third-Party Sharing</h2>
      <p>We do not sell your data. We only share it with trusted service providers as necessary to operate our platform.</p>

      <h2>Security</h2>
      <p>We implement standard security measures to protect your data. However, no method is 100% secure.</p>

      <p>Questions? Email support@mydailyreminders.com.</p>
    </div>
  );
}
